import { Checkbox, type CheckboxProps } from '@mui/material';

export interface TableCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  indeterminate?: boolean;
}

/**
 * Standardized checkbox component for table rows.
 * Always renders as size="small" for consistent appearance.
 */
export function TableCheckbox({
  checked,
  onChange,
  disabled,
  indeterminate,
}: TableCheckboxProps) {
  const handleChange: CheckboxProps['onChange'] = event => {
    onChange?.(event.target.checked);
  };

  return (
    <Checkbox
      size="small"
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      indeterminate={indeterminate}
    />
  );
}
